import * as types from "./types";
import createReducer from "../../utils/createReducer";

import initialState from './initialState';

let reducersMap = {
   [types.FETCH_CAST_MEMBERS_LIST_START]: (state, action) => {
      const { isFetchingByFilter, isFetchingNextPage } = action.payload

      let newState = {
         isFetchingList: !isFetchingByFilter && !isFetchingNextPage,
         isFetchingByFilter: isFetchingByFilter,
         isFetchingNextPage: isFetchingNextPage,
      }

      return {
         ...state,
         ...newState,
      }
   },
   [types.FETCH_CAST_MEMBERS_LIST_COMPLETED]: (state, action) => {
      const { list, isFetchingNextPage } = action.payload

      let newState = {
         isFetchingList: false,
         isFetchingByFilter: false,
         isFetchingNextPage: false,
      }

      if(isFetchingNextPage) {
         newState.list = {
            ...list,
            data: [...state.list.data, ...list.data],
         }
      } else {
         newState = {
            ...newState,
            list: { ...list },
         }
      }

      return {
         ...state,
         ...newState,
      }
   },
   [types.OPEN_CLOSE_CONFIRM_DIALOGS]: (state, action) => {
      const { isOpen, type, castMemberData } = action.payload

      return {
         ...state,
         confirmDialogs: {
            ...state.confirmDialogs,
            isOpen,
            type,
            castMemberData,
         },
      }
   },
   [types.SET_IS_FETCHING_ACTION_WITH_CAST_MEMBER]: (state, action) => {

      return {
         ...state,
         isFetchingActionWithCastMember: action.payload,
      }
   },
   [types.DELETE_CAST_MEMBER_COMPLETED]: (state, action) => {
      const { id } = action.payload;

      return {
         ...state,
         isFetchingActionWithCastMember: false,
         list: {
            ...state.list,
            data: state.list.data.filter(cast => cast.id !== id),
         },
      }
   },
   [types.SET_IS_FETCHING_CAST_MEMBER_DETAILS]: (state, action) => {

      return {
         ...state,
         isFetchingCastMemberDetails: action.payload,
      }
   },
   [types.SET_IS_FETCHING_CREATE_CAST_MEMBER]: (state, action) => {

      return {
         ...state,
         isFetchingCreate: action.payload,
      }
   },
   [types.FETCH_CREATE_EDIT_CAST_MEMBER_FAILED]: (state, action) => {
      const errors = action.payload
      let updatedState = {
         isFetchingCreate: false,
         isFetchingUpdate: false,
         createEditErrors: errors || {},
      }

      return {
         ...state,
         ...updatedState,
      }
   },
   [types.RESET_ERRORS]: (state, action) => {
      const { errors, isAll } = action.payload

      let newErrors = {}

      if(!isAll) {
         newErrors = {
            ...state.createEditErrors,
            ...errors,
         }
      }

      return {
         ...state,
         createEditErrors: newErrors,
      }
   },
   [types.SET_IS_FETCHING_UPDATE_CAST_MEMBER]: (state, action) => {

      return {
         ...state,
         isFetchingUpdate: action.payload,
      }
   },
   [types.REORDER_CAST_MEMBERS]: (state, action) => {

      return {
         ...state,
         list: {
            ...state.list,
            data: action.payload,
         },
      }
   },
   [types.SET_FETCHING_TURN_ON_OFF_PROFILE_PAGE_ID]: (state, action) => {
      const { id, isFetching } = action.payload

      let updatedState = {}

      if(isFetching) {
         updatedState.fetchingTurnOnOffProfilePageIds = [...state.fetchingTurnOnOffProfilePageIds, id]
      } else {
         updatedState.fetchingTurnOnOffProfilePageIds = state.fetchingTurnOnOffProfilePageIds.filter(fetchingId => fetchingId !== id)
      }

      return {
         ...state,
         ...updatedState,
      }
   },
   [types.TURN_ON_OFF_CAST_MEMBER_PROFILE_PAGE_COMPLETED]: (state, action) => {
      const { id, updatePayload } = action.payload

      let updatedState = {
         fetchingTurnOnOffProfilePageIds: state.fetchingTurnOnOffProfilePageIds.filter(fetchingId => fetchingId !== id),
      }

      if(state.list.data) {
         updatedState.list = {
            ...state.list,
            data: state.list.data.map(cast => {
               if(cast.id === id) {
                  return {
                     ...cast,
                     ...updatePayload,
                  }
               }

               return cast
            }),
         }
      }

      return {
         ...state,
         ...updatedState,
      }
   },
}

export default createReducer(initialState)(reducersMap);
